import { motion } from "framer-motion";
import { FaEnvelope, FaGithub, FaLinkedin, FaKaggle } from "react-icons/fa";
import GridBackground from "./Grid";
import Experience from "./Experience";
import Impact from "./Impact";
import Skills from "./Skills";
import Projects from "./Projects";
import Publications from "./Publications";
import Certificates from "./Certificates";
import yLogo from "../assets/optimized/yLogo.webp";
import meEmoji from "../assets/me.png";

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07 } },
};

const fadeUp = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.25, 0.1, 0.25, 1] } },
};

function Header() {
  return (
    <div className="relative w-full overflow-hidden">
      <GridBackground />

      <div className="site-container hero-container relative z-10">
        <motion.div
          className="page-stack"
          variants={stagger}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="hero-intro" variants={fadeUp}>
            <div className="hero-profile">
              <div className="hero-profile-content">
                <div className="hero-heading">
                  <img
                    src={yLogo}
                    alt="Yahya Momtaz logo"
                    width="52"
                    height="52"
                    decoding="async"
                    className="hero-logo"
                  />
                  <h1 className="hero-title font-semibold text-zinc-100">
                    Yahya Momtaz
                  </h1>
                </div>

                <p className="hero-copy text-zinc-500">
                  Tech GeeK through-and-through, I work on development, cloud infrastructure and AI. Experienced in python (API's are my specialty), have some basic front-end experience.
                </p>
              </div>

              <img
                src={meEmoji}
                alt="Yahya Momtaz emoji"
                width="271"
                height="335"
                decoding="async"
                className="hero-emoji emoji-playful"
              />
            </div>

            <div className="hero-actions">
              <a
                href="mailto:yahyamomtaz@gmail.com"
                className="hero-action hero-action--contact"
              >
                <span className="hero-action-badge" aria-hidden="true">
                  <FaEnvelope className="hero-action-icon hero-contact-icon" />
                </span>
                Contact Me
              </a>
              <a
                href="https://github.com/yahyamomtaz"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-action hero-action--social"
              >
                <span className="hero-action-badge" aria-hidden="true">
                  <FaGithub className="hero-action-icon text-zinc-900" />
                </span>
                GitHub
              </a>
              <a
                href="https://www.linkedin.com/in/yahya-momtaz-601b34108/"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-action hero-action--social"
              >
                <span className="hero-action-badge" aria-hidden="true">
                  <FaLinkedin className="hero-action-icon text-[#0A66C2]" />
                </span>
                LinkedIn
              </a>
              <a
                href="https://www.kaggle.com/yahyamomtaz"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-action hero-action--social"
              >
                <span className="hero-action-badge" aria-hidden="true">
                  <FaKaggle className="hero-action-icon text-[#20BEFF]" />
                </span>
                Kaggle
              </a>
            </div>
          </motion.div>

          <Skills />

          <div className="content-stack">
            <Experience />
            <Impact />
            <Projects />
            <Publications />
            <Certificates />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Header;
